import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import type { RequestPropsType } from './request-interceptor';
import { requestInterceptor } from './request-interceptor';
import { setTokenReceivedAt } from './utils';

const setAuthToken = (value: string) => {
    const valueExists = value !== null && value !== undefined;
    const tokenReceivedAt = Math.floor(Date.now() / 1000);
    if (valueExists) {
        setTokenReceivedAt(tokenReceivedAt);
        requestInterceptor.setHeader('Authorization', `Bearer ${value}`);
    }
};

const setCSRFToken = (value: string) => {
    requestInterceptor.setHeader('X-CSRF-Token', value);
};

(function addOrgsOverrideHeader() {
    requestInterceptor.addHeaderRule('x-thoughtspot-orgsoverride', () => {
        const header: Record<string, string> = {};
        const overrideOrgId = envFlags.getValue(FLAGS.overrideOrgId.name);
        if (overrideOrgId != null && overrideOrgId !== -1) {
            header['x-thoughtspot-orgsoverride'] = overrideOrgId;
    }
        return header;
    });
})();



const overrideBrowserFetch = (args: RequestPropsType) => {
    requestInterceptor.overrideFetch(args);
};

const overrideBrowserXhr = (args: RequestPropsType) => {
    requestInterceptor.overrideXHR(args);
};

const overrideBrowserRequest = (args: RequestPropsType) => {
    requestInterceptor.overrideFetch(args);
    requestInterceptor.overrideXHR(args);
};

const overrideRequestOptions = (args: any) => {
    return requestInterceptor.overrideOptions(args);
};

export {
    setAuthToken,
    setCSRFToken,
    overrideBrowserRequest,
    overrideBrowserFetch,
    overrideBrowserXhr,
    overrideRequestOptions,
    RequestPropsType,
};
